/**
 * Created by Jie Gao on 2017-05-26.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ISpriteConfig} from "../animation/IAnimationConfig";

export class AnimationHelper {

    public static createSprite(spriteConfig:ISpriteConfig):PIXI.Sprite {
        const sprite = new PIXI.Sprite(GameResources.getTextures(spriteConfig.texture)[0]);
        if(spriteConfig.blendMode) {
            sprite.blendMode = spriteConfig.blendMode!;
        }
        sprite.x = 0;
        sprite.y = 0;
        sprite.anchor.set(0.5, 0.5);
        sprite.alpha = 0;
        return sprite;
    }

    public static createTimelineSprite(texture:PIXI.Texture[]):TimelineSprite {
        const sprite = new TimelineSprite(texture);
        sprite.x = 0;
        sprite.y = 0;
        sprite.anchor.set(0.5, 0.5);
        sprite.alpha = 0;
        return sprite;
    }
}